import { SvgIcon, SvgIconProps } from "@mui/material";

export const CalendarInputIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "18", height: "18", fill: "none" }}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M2 3H16C16.5523 3 17 3.44771 17 4V16C17 16.5523 16.5523 17 16 17H2C1.44772 17 1 16.5523 1 16V4C1 3.44772 1.44772 3 2 3Z"
        stroke="#111111"
        strokeWidth="2"
      />
      <path d="M1 8H17" stroke="#111111" strokeWidth="2" />
      <path d="M14 1C14 0.447715 13.5523 0 13 0C12.4477 0 12 0.447715 12 1H14ZM13 3H14V1H13H12V3H13Z" fill="#111111" />
      <path d="M6 1C6 0.447715 5.55228 0 5 0C4.44772 0 4 0.447715 4 1H6ZM5 3H6V1H5H4V3H5Z" fill="#111111" />
    </SvgIcon>
  );
};

export const UnSelectedChipIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "10", height: "10", fill: "none" }}
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
    >
      <path d="M5 1V9" stroke="#707070" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M9 5L1 5" stroke="#707070" strokeWidth="1.5" strokeLinecap="round" />
    </SvgIcon>
  );
};

export const SelectedChipIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "10", height: "8", fill: "none" }}
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="none"
    >
      <path d="M1 3.61872L3.90909 6.66634L9 1.33301" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    </SvgIcon>
  );
};
